import RightSlider from 'component/hoc/rightSlider/RightSlider';
import React, { useEffect } from 'react';
import { FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';
import toast from 'react-hot-toast';
import InitialForm from 'component/organism/workflow/forms/trigger/InitialForm';
import { isEqual } from 'lodash';

const InitialModal = ({ isOpen, onClose, id, isError, isSystem }) => {
  const {
    workflowData,
    setWorkflowData,
    selectedNode,
    initialWorkflowData,
    setIsChanged,
  } = useWorkflowContext();
  const formik = useFormik({
    initialValues: {
      triggerTypeId:
        selectedNode?.createWorkFlow_Intents?.triggerTypeId || 'intent',
      name: selectedNode?.createWorkFlow_Intents?.name || '',
      description: selectedNode?.createWorkFlow_Intents?.description || '',
      utterances: selectedNode?.createWorkFlow_Intents?.utterances || [],
      // reassessIntent: selectedNode?.capture?.reassessIntent || false,
      hasSuggestions: selectedNode?.hasSuggestions || false,
      hasAIGenerated: selectedNode?.hasAIGenerated || false,
      idleTime: workflowData?.idleTime || 0,
      suggestedQuestions: selectedNode?.suggestedQuestions?.map((q, index) => ({
        question: q.question || '',
      })) || [{ question: '' }],
    },
    enableReinitialize: true,
    validateOnMount: true,
    validationSchema: Yup.object({
      triggerTypeId: Yup.string().required('Required'),
      name: Yup.string().required('Required'),
      description: Yup.string(),
      idleTime: Yup.number(),
      utterances: Yup.array().of(Yup.string().required('Required')),
      hasSuggestions: Yup.boolean(),
      hasAIGenerated: Yup.boolean(),
      suggestedQuestions: Yup.array()
        .max(4, 'You can add up to 4 suggested questions only')
        .of(
          Yup.object().shape({
            question: Yup.string()
              .max(30, 'Question cannot exceed 30 characters')
              .required('Question is required'),
          })
        ),
    }),
    onSubmit: (values, { setSubmitting, resetForm }) => {},
  });

  const initialNode = initialWorkflowData?.find((node) => node?.id === id);

  const handleSubmit = async () => {
    await formik.handleSubmit();
    try {
      setTimeout(() => {
        const updatedNodes = workflowData?.nodes?.map((node) =>
          node.id === id
            ? {
                ...node,
                createWorkFlow_Intents: {
                  name: formik.values.name,
                  description: formik.values.description,
                  utterances: formik.values.utterances,
                },
                is_Error: isError,
                hasSuggestions: formik.values.hasSuggestions,
                hasAIGenerated: formik.values.hasAIGenerated,
                suggestedQuestions: formik.values.suggestedQuestions,
              }
            : node
        );

        setWorkflowData((prev) => ({
          ...prev,
          ...(workflowData?.systemId === 5 && {
            idleTime: formik.values.idleTime,
          }),
          nodes: updatedNodes,
        }));

        if (initialNode) {
          const { triggerTypeId, name, description, utterances } =
            initialNode?.createWorkFlow_Intents || {};
          const initialMessageObject = {
            name,
            description,
            utterances,
            suggestedQuestions:
              initialNode?.suggestedQuestions === undefined
                ? [{ question: '' }]
                : initialNode?.suggestedQuestions,
            hasSuggestions: initialNode?.hasSuggestions,
            hasAIGenerated: initialNode?.hasAIGenerated,
          };
          const currentValues = {
            name: formik.values.name,
            description: formik.values.description,
            utterances: formik.values.utterances,
            suggestedQuestions: formik.values.suggestedQuestions,
            hasSuggestions: formik.values.hasSuggestions,
            hasAIGenerated: formik.values.hasAIGenerated,
          };
          const changed = !isEqual(currentValues, initialMessageObject);

          setIsChanged((prev) => {
            const alreadyExists = prev?.includes(id);
            if (changed && !alreadyExists) {
              return [...prev, id];
            }
            if (!changed && alreadyExists) {
              return prev?.filter((nodeId) => nodeId !== id);
            }

            return prev;
          });
        }
        onClose();
        formik.resetForm();
      }, [100]);
    } catch {
      toast.error('Something went wrong');
    }
  };
  useEffect(() => {
    if (!isError) {
      const updatedNodes = workflowData?.nodes?.map((node) =>
        node.id === id ? { ...node, is_Error: isError } : node
      );

      setWorkflowData((prev) => ({
        ...prev,
        nodes: updatedNodes,
      }));
    }
  }, [isError]);

  useEffect(() => {
    if (isError) {
      formik.handleSubmit();
    }
  }, [isOpen]);

  return (
    <RightSlider
      title='Triggers'
      action={{
        isOpen: isOpen,
        setIsOpen: handleSubmit,
      }}
    >
      <FormikProvider value={formik}>
        {/* <TriggerForm /> */}
        <InitialForm systemId={workflowData?.systemId} isSystem={isSystem} />
      </FormikProvider>
    </RightSlider>
  );
};

export default InitialModal;
